import { createFileRoute } from '@tanstack/react-router';
import ApplicationsListPage from '@/components/DeveloperApplications/ApplicationsListPage';

export const Route = createFileRoute('/developers/applications/')({
  component: ApplicationsListPage,
});
